export default "__VITE_ASSET__CaKhzzue__"